import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { getConnection, getErrorMessage, hideSpinner, showSpinner } from 'src/app/core/services/functions.service';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { ModuloMenu } from 'src/app/core/services/menu.service';
import { ModuloMenuSicfModel } from '../../models/modulo-menu.model';
import { ModulosService } from '../../services/modulos.service';
import { arrayNotEmpty } from 'class-validator';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-modulos',
  templateUrl: './modulos.component.html',
  styleUrls: ['./modulos.component.scss']
})
export class ModulosComponent implements OnInit {

  modules: ModuloMenu[] = []
  selectedModule: ModuloMenuSicfModel | undefined

  form: FormGroup
  icons: string[] = []

  constructor(
    private modulosService: ModulosService,
    private helpers: HelpersService,
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
  ) {
    this.form = this.formBuilder.group({
      activo: ["", [Validators.required, Validators.maxLength(1)]],
      descripcion_modulo: ["", [Validators.required]],
      imagen_url: [""],
      descripcion_larga: [""],
      url_default: [""],
    })
    this.resetForm()
  }

  async ngOnInit() {
    const data = this.activatedRoute.snapshot.data
    if (data.title) {
      this.helpers.setTitle(data.title);
    }
    showSpinner()
    await this.getAllModules()
    await this.getIcons()
    hideSpinner()
  }

  async getIcons() {
    try {
      this.icons = await this.helpers.getIcons()
    } catch (error) {
      const message = getErrorMessage(error)
      this.helpers.notifications.errorMessage(message)
    }
  }

  resetForm(selectedModule: ModuloMenuSicfModel | undefined = undefined) {
    if (selectedModule == undefined) {
      this.selectedModule = undefined
      this.form.reset()
    } else {
      this.form.get("c_emp")?.setValue(selectedModule?.c_emp)
      this.form.get("codigo_modulo")?.setValue(selectedModule?.codigo_modulo)
      this.form.get("activo")?.setValue(selectedModule?.activo)
      this.form.get("descripcion_modulo")?.setValue(selectedModule?.descripcion_modulo)
      this.form.get("imagen_url")?.setValue(selectedModule?.imagen_url)
      this.form.get("descripcion_larga")?.setValue(selectedModule?.descripcion_larga)
      this.form.get("url_default")?.setValue(selectedModule?.url_default)
    }
  }

  async getAllModules() {
    showSpinner()
    try {
      const result = await this.modulosService.findAll()
      if (result.success) {
        this.modules = result.data
      } else {
        this.helpers.notifications.errorMessage(result.message)
      }
    } catch (error) {
      const message = getErrorMessage(error)
      this.helpers.notifications.errorMessage(message)
    }
    hideSpinner()
  }

  async getOneModule(codigo: string) {
    try {
      const result = await this.modulosService.findOne(codigo)
      if (result.success) {
        return result.data
      } else {
        this.helpers.notifications.errorMessage(result.message)
        return null
      }
    } catch (error) {
      const message = getErrorMessage(error)
      this.helpers.notifications.errorMessage(message)
      return null
    }
  }

  async selectModule(selected: any[]) {
    showSpinner()
    if (arrayNotEmpty(selected) && selected[0].codigo) {
      this.selectedModule = undefined
      this.selectedModule = await this.getOneModule(selected[0].codigo)
      if (this.selectedModule?.codigo_modulo) {
        this.resetForm(this.selectedModule)
      }
    }
    hideSpinner()
  }

  async create() {
    showSpinner()
    if (this.form.valid) {
      try {
        const result = await this.modulosService.create(this.form.value)
        if (result.success) {
          await this.getAllModules()
          this.helpers.notifications.successMessage(result.message)
        } else {
          this.helpers.notifications.errorMessage(result.message)
        }
        hideSpinner()
      } catch (error) {
        hideSpinner()
        const message = getErrorMessage(error)
        this.helpers.notifications.errorMessage(message)
      }
    } else {
      hideSpinner()
      this.helpers.notifications.errorMessage("Debe completar algunos campos o son demasiado largos")
    }
  }

  async modify() {
    showSpinner()
    if (this.form.valid && this.selectedModule && this.selectedModule.codigo_modulo) {
      try {
        const result = await this.modulosService.update(this.form.value, {
          c_emp: getConnection(),
          codigo_modulo: this.selectedModule?.codigo_modulo
        })
        if (result.success) {
          await this.selectModule([{ codigo: result.data.current[0].codigo_modulo }])
          this.getAllModules()
          this.helpers.notifications.successMessage(result.message)
        } else {
          this.helpers.notifications.errorMessage(result.message)
        }
        hideSpinner()
      } catch (error) {
        hideSpinner()
        const message = getErrorMessage(error)
        this.helpers.notifications.errorMessage(message)
      }
    } else {
      hideSpinner()
      this.helpers.notifications.errorMessage("Debe completar algunos campos o son demasiado largos")
    }
  }

  print(value) {
    return JSON.stringify(value)
  }

}

